type Translations = Record<string, any>;

class I18n {
  private translations: Translations = {};
  private currentLang: string = 'ru';
  private fallbackLang: string = 'ru';
  private listeners: Set<() => void> = new Set();

  async init(lang?: string): Promise<void> {
    this.currentLang = lang || localStorage.getItem('eco-lang') || navigator.language.split('-')[0] || this.fallbackLang;
    console.log('i18n current language = ', this.currentLang);
    if (!['ru', 'en'].includes(this.currentLang)) this.currentLang = this.fallbackLang;
    await this.loadTranslations(this.currentLang);
  }

  private async loadTranslations(lang: string): Promise<void> {
    try {
      const response = await fetch(`/locales/${lang}.json`);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      this.translations = await response.json();
      localStorage.setItem('eco-lang', lang);
      this.currentLang = lang;
      this.notifyListeners();
    } catch (error) {
      console.error(`[i18n] Error loading ${lang}:`, error);
      if (lang !== this.fallbackLang) {
        await this.loadTranslations(this.fallbackLang);
      }
    }
  }

  // Поддержка вложенных ключей: 'app.title' -> translations.app.title
  t(key: string, params?: Record<string, string>): string {
    const keys = key.split('.');
    let result: any = this.translations;
    
    for (const k of keys) {
      if (result === undefined || result === null) break;
      result = result[k];
    }
    
    let text = typeof result === 'string' ? result : key;
    
    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        text = text.replace(`{{${k}}}`, String(v));
      });
    }
    return text;
  }

  get lang(): string { return this.currentLang; }

  onChange(callback: () => void): () => void {
    this.listeners.add(callback);
    return () => this.listeners.delete(callback);
  }

  private notifyListeners(): void {
    this.listeners.forEach(cb => cb());
  }

  switchLang(lang: string): Promise<void> {
    return this.loadTranslations(lang);
  }
}

export const i18n = new I18n();